import SelectedMeals from './SelectedMeals'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as orderSelectors from '../../../selectors/order'

import {
  addProduct,
  removeProduct,
  clearOrder
} from '../../../store/actions/order'

const mapStateToProps = state => ({
  products: orderSelectors.getOrder(state),
  mealCount: orderSelectors.getOrderMealCount(state),
  subtotal: orderSelectors.getOrderSubtotal(state),
  orderSummaryLoading: orderSelectors.orderSummaryLoading(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addProduct,
      removeProduct,
      clearOrder
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(SelectedMeals)



// WEBPACK FOOTER //
// ./src/modules/Menu/SelectedMeals/index.js